import React from 'react';
import cx from 'classnames';

interface LogoProps {
  logoUrl: string;
  className?: string;
}

const Logo = ({ logoUrl, className }: LogoProps) => (
  <div className={cx('text-center py-2.5 h-14', className)}>
    <div className='image-holder h-full'>
      <img className='h-full share-logo' src={logoUrl} />
    </div>
  </div>
);

export default Logo;
